import React, { Component } from 'react';
import Page from '../../components/Page';
import { Icon, Segment, Form, Table, Button, Modal, Header, Menu } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import moment from 'moment';

const TABS = [
	{ key: 'telegramList', label: 'Telegram Bot API' },
	{ key: 'contactList', label: 'Telegram Web API' },
];

class Phones extends Component {
	state = {
		activeTab: 'telegramList',
		loading: true,
		telegramList: [],
		contactList: [],
		loadingBtn: false,
		message: false,
		openModal: false,
		deleteModal: false,
		numberList: [],
		selectedExcel: null,
		deleteButtonLoading: false,
	};

	componentDidMount() {
		Promise.all([this.getList('telegramList'), this.getList('contactList')]).then(() => {
			this.setState({ loading: false });
		});
	}

	getList(key) {
		const { product } = this.props;
		let pid = product.id;
		return fetch(`https://micro.yapaytech.com/api/forex_contacts/readMulti?pid=${pid}&key=${key}`)
			.then((response) => response.json())
			.then((data) => {
				this.setState({ [key]: data.result || [] });
			});
	}

	deleteList() {
		const { product } = this.props;
		let pid = product.id;
		let { selectedExcel, activeTab } = this.state;
		this.setState({ deleteButtonLoading: true });
		fetch(`https://micro.yapaytech.com/api/forex_contacts/remove`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ pid, id: selectedExcel._id }),
		})
			.then((response) => response.json())
			.then(() => {
				this.setState({ deleteButtonLoading: false, deleteModal: false });
				this.getList(activeTab);
			});
	}

	fileUpload(file) {
		const { product } = this.props;
		let { activeTab } = this.state;
		this.setState({ loadingBtn: true });
		let pid = product.id;
		const url = 'https://micro.yapaytech.com/api/forex_contacts/write/excel';
		const formData = new FormData();
		formData.append('file', file);
		formData.append('pid', pid);
		formData.append('key', activeTab);
		fetch(url, { method: 'post', body: formData })
			.then((response) => response.json())
			.then(() => {
				this.setState({ loadingBtn: false, message: true });
				this.getList(activeTab);
			});
	}

	handleFileInput = (e) => {
		let file = e.target.files[0];
		this.fileUpload(file);
	};

	downloadExample = () => {
		var a = document.createElement('a');
		a.href = '/contacts_example.xlsx';
		a.target = '_blank';
		a.download = 'contacts_example.xlsx';
		a.click();
	};

	renderList(list) {
		const { t } = this.props;
		return (
			<Table>
				<Table.Header>
					<Table.Row>
						<Table.HeaderCell>{'Name'}</Table.HeaderCell>
						<Table.HeaderCell>{'Date'}</Table.HeaderCell>
						<Table.HeaderCell>{'Count'}</Table.HeaderCell>
						<Table.HeaderCell></Table.HeaderCell>
					</Table.Row>
				</Table.Header>
				<Table.Body>
					{_.map(list, (it) => (
						<Table.Row key={it._id}>
							<Table.Cell>{it.filename || moment(it.date).format('DD-MM-YYYY HH:mm:ss')}</Table.Cell>
							<Table.Cell>{moment(it.date).format('DD-MM-YYYY')}</Table.Cell>
							<Table.Cell>{it.data && it.data.length}</Table.Cell>
							<Table.Cell>
								<Button
									icon
									size="mini"
									style={{ marginLeft: '10px' }}
									onClick={() => this.setState({ openModal: true, numberList: it.data, selectedExcel: it })}
								>
									<Icon name="eye" />
								</Button>
								<Button
									icon
									size="mini"
									style={{ marginLeft: '10px' }}
									onClick={() => this.setState({ deleteModal: true, numberList: it.data, selectedExcel: it })}
								>
									<Icon name="trash" />
								</Button>
							</Table.Cell>
						</Table.Row>
					))}
				</Table.Body>
			</Table>
		);
	}

	render() {
		const { t } = this.props;
		let { loadingBtn, message, activeTab, loading } = this.state;

		if (loading) return <Page.Loader />;

		let activeTabObj = _.find(TABS, { key: activeTab });
		let list = this.state[activeTab] || [];

		return (
			<Segment>
				<Menu pointing secondary>
					{_.map(TABS, (tab) => (
						<Menu.Item
							key={tab.key}
							active={activeTab === tab.key}
							onClick={() => this.setState({ activeTab: tab.key, message: false })}
						>
							<Icon name="telegram" />
							{tab.label}
						</Menu.Item>
					))}
				</Menu>

				<div style={{ padding: '10px', width: '100%' }}>
					<Form>
						<Form.Field style={{ display: 'flex', marginBottom: '10px' }}>
							<div className="image-upload" style={{ margin: 'auto' }}>
								<label
									htmlFor={`file-input-${activeTab}`}
									className={`ui blue icon left labeled button ${loadingBtn ? 'loading' : ''}`}
								>
									{t('upload')}
									<Icon name="upload" style={{ cursor: 'pointer' }} />
								</label>
								<Button
									onClick={this.downloadExample}
									content={t('example download')}
									icon="download"
									labelPosition="left"
									color="teal"
								/>
							</div>
							<input
								id={`file-input-${activeTab}`}
								type="file"
								accept=".xlsx, .xls"
								style={{ display: 'none' }}
								onChange={this.handleFileInput}
							/>
						</Form.Field>
						{message && <p style={{ textAlign: 'center' }}>{t('messageExcelSuccess')}</p>}
					</Form>
				</div>

				{this.renderList(list)}

				<Modal open={this.state.openModal} onClose={() => this.setState({ openModal: false })} closeIcon>
					<Modal.Header>{this.state.selectedExcel && this.state.selectedExcel.filename}</Modal.Header>
					<Modal.Content>
						<Table>
							<Table.Header>
								<Table.Row>
									<Table.HeaderCell>{'Id'}</Table.HeaderCell>
									<Table.HeaderCell>{'Name'}</Table.HeaderCell>
									<Table.HeaderCell>{'Phone'}</Table.HeaderCell>
									<Table.HeaderCell>{'Website'}</Table.HeaderCell>
								</Table.Row>
							</Table.Header>
							<Table.Body>
								{_.map(this.state.numberList, (it, i) => (
									<Table.Row key={i}>
										<Table.Cell>{it['Users Id']}</Table.Cell>
										<Table.Cell>{it.Name || it.isim}</Table.Cell>
										<Table.Cell>{it.Phone}</Table.Cell>
										<Table.Cell>{it.Website}</Table.Cell>
									</Table.Row>
								))}
							</Table.Body>
						</Table>
					</Modal.Content>
				</Modal>

				<Modal open={this.state.deleteModal} onClose={() => this.setState({ deleteModal: false })}>
					<Header icon="dont" content={t('delete')} />
					<Modal.Content>
						<p>{t('areYouSureDeleteExcel')}</p>
					</Modal.Content>
					<Modal.Actions>
						<Button color="red" onClick={() => this.setState({ deleteModal: false })}>
							<Icon name="remove" /> {t('no')}
						</Button>
						<Button color="green" onClick={() => this.deleteList()} loading={this.state.deleteButtonLoading}>
							<Icon name="checkmark" /> {t('yes')}
						</Button>
					</Modal.Actions>
				</Modal>
			</Segment>
		);
	}
}

const stateToProps = (state) => ({
	access: state.access,
	location: state.router.location,
	product: state.product.live,
	user: state.access.user.loggedUserObj,
});

export default connect(stateToProps)(withTranslation()(Phones));
